{
  "header": "Détails de l'équipement",
  "subtitle": "L'équipement attaché à votre camion (remorque, conteneur, etc.).",
  "assetType": "Type d'équipement",
  "assetTypePlaceholder": "Sélectionner le type d'équipement",
  "assetId": "ID de l'équipement (ex. numéro de remorque)",
  "assetIdPlaceholder": "Ex. : numéro de remorque, ID de conteneur, etc.",
  "remove": "Supprimer",
  "addAnother": "Ajouter un autre équipement",
  "trailerType": "Type de remorque",
  "trailerId": "ID de la remorque"
}
